import PropTypes from 'prop-types';

import { formatCustomerAssignment } from '#/modules/crmMgmt/aftersales/snProductMapping/helper/productCode';
import { formatDateTimeOrDash } from '#/utils/date';

function displayDash(value) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return value;
}

const InfoField = ({ label, value }) => (
  <div className="min-w-0">
    <p className="text-xs text-gray-500">{label}</p>
    <p className="mt-0.5 text-sm font-medium wrap-break-word text-gray-900">{value}</p>
  </div>
);

InfoField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
};

/**
 * 編輯頁上方唯讀資訊卡（GET detail 快照）。
 * 啟用／停用後產品代碼與客戶不可改（identityLocked），改在此顯示；其餘欄位在下方表單編輯。
 */
const SnProductMappingEditInfoCard = ({
  detail,
  customer,
  customerLoading = false,
  identityLocked = false,
}) => {
  const customerLabel = customerLoading
    ? '載入中…'
    : formatCustomerAssignment(detail?.customerId, customer);

  return (
    <section className="receipt-card-elevate mb-4">
      <div className="receipt-card-surface p-5">
        <h2 className="form-block__title">對照資料（唯讀）</h2>
        {identityLocked ? (
          <p className="form-block__description">
            已啟用或停用，產品代碼與客戶不可更改，只能修改下方的產品名稱與備註。
          </p>
        ) : null}
        <div className="mt-4 grid grid-cols-1 gap-x-4 gap-y-3 border-t border-slate-200 pt-4 sm:grid-cols-2">
          {identityLocked ? (
            <>
              <InfoField label="產品代碼" value={displayDash(detail?.productCode)} />
              <InfoField label="客戶" value={customerLabel} />
            </>
          ) : null}
          <InfoField
            label="建立"
            value={formatDateTimeOrDash(detail?.record?.createdAt)}
          />
          <InfoField
            label="修改"
            value={formatDateTimeOrDash(detail?.record?.updatedAt)}
          />
        </div>
      </div>
    </section>
  );
};

SnProductMappingEditInfoCard.propTypes = {
  detail: PropTypes.object,
  customer: PropTypes.object,
  customerLoading: PropTypes.bool,
  identityLocked: PropTypes.bool,
};

export default SnProductMappingEditInfoCard;
